module.exports = "/assets/data/877e77d4ad41fe39402644f441f88b72-GL6.data.json";